import { render, staticRenderFns } from "./BaseTextField.vue?vue&type=template&id=1596c7d0&scoped=true"
import script from "./BaseTextField.vue?vue&type=script&lang=js"
export * from "./BaseTextField.vue?vue&type=script&lang=js"
import style0 from "./BaseTextField.vue?vue&type=style&index=0&id=1596c7d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1596c7d0",
  null
  
)

export default component.exports